/**
 * Vitest fork pool id (digits only), shared by testSetup (worker User id) and apiClient
 * (token suffix for Lambda `resolveParallelTestWorkerDynamoUserId`).
 *
 * Vitest sets both `VITEST_POOL_ID` (tinypool worker index) and `VITEST_WORKER_ID` (ctx.workerId).
 * We prefer POOL then WORKER and require a non-empty digit string so `*-testworker-<n>` matches
 * the backend suffix regex.
 */
export function getVitestParallelPoolId(): string | null {
  const raw =
    process.env.VITEST_POOL_ID ?? process.env.VITEST_WORKER_ID ?? "";
  const poolId = String(raw).trim();
  if (!poolId || !/^\d+$/.test(poolId)) {
    return null;
  }
  return poolId;
}
